/**
 * Frontend Idempotency Key Generator
 * Mirrors the backend implementation for consistency
 */

export const generateOrderIdempotencyKey = (userID, orderType, tableNo) => {
    // Use table number for dine-in, order type for others
    const identifier = tableNo || orderType || 'online';

    // Milliseconds plus a random suffix prevents two rapid orders from the same
    // cashier/order type receiving the same key.
    const timestamp = Date.now();
    const randomSuffix = window.crypto?.randomUUID
        ? window.crypto.randomUUID().replace(/-/g, '')
        : `${Math.random().toString(36).slice(2)}${Math.random().toString(36).slice(2)}`;

    const key = `ORDER-${userID}-${identifier}-${timestamp}-${randomSuffix}`;

    console.log(`[IDEMPOTENCY-FRONTEND] Generated key: ${key}`);
    return key;
};

export const isValidIdempotencyKey = (key) => {
    if (!key || typeof key !== 'string') return false;
    const pattern = /^ORDER-\d+-[\w-]+-\d+(?:-[a-zA-Z0-9]+)?$/;
    return pattern.test(key);
};